import { createAction } from "redux-actions";

import {
  SET_APP_VERSION,
  SET_FLOOR,
  SET_LOCALE,
  SET_PLATFORM,
  SET_COUNTRY,
  SET_CURRENCY,
  SET_STORE_URL,
  SET_SIZE_SCHEMA,
  SET_GEOLOCATION
} from "../constants";

export const setAppVersion = createAction(SET_APP_VERSION);
export const setFloor = createAction(SET_FLOOR);
export const setLocale = createAction(SET_LOCALE);
export const setPlatform = createAction(SET_PLATFORM);
export const setCountry = createAction(SET_COUNTRY);
export const setCurrency = createAction(SET_CURRENCY);
export const setStoreUrl = createAction(SET_STORE_URL);
export const setSizeSchema = createAction(SET_SIZE_SCHEMA);
export const setGeolocation = createAction(SET_GEOLOCATION);
export { default as setLoyaltyIsEnabled } from "./setLoyaltyIsEnabled";
export { default as setLoyaltyTier } from "./setLoyaltyTier";
export { default as loadLoyaltyCustomerTierId } from "./loadLoyaltyCustomerTierId";
export { default as loyaltyOptIn } from "./loyaltyOptIn";
export { default as loadLoyaltyIsEnabled } from "./loadLoyaltyIsEnabled";
export { default as loadLoyaltyIsInvited } from "./loadLoyaltyIsInvited";
export { default as setLoyaltyIsInvited } from "./setLoyaltyIsInvited";
